import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators,  } from "@angular/forms";
import { Subscription, Observable, of } from "rxjs";
import { tap, map } from "rxjs/operators";
import { WellService } from "../../../services/well.service";
import { FlowIndexSpec, FlowInstanceService } from "../../../../flow/services/flow-instance.service";
import { OrganizationService } from "../../../services/organization.service";
import { requireOneOption } from "../../../models/scan-documents.model";
import { OrganizationStub } from "../../../models/organization.model";
import { OnBaseIntegrationAndMappingService } from "../../../services/onbase-integration-mapping.service";
import { OnBaseDocumentType, OnBaseDocumentGroup } from '../../../models/onBaseIntegrationAndMapping.model';
import { DocumentManagementService } from "../../../services/document-management.service";



@Component({
    selector: 'scan-document-details',
    templateUrl: './scan-document-details.component.html',
    styleUrls: ['./scan-document-details.component.scss'],
    standalone: false
})
export class ScanDocumentDetailsComponent implements OnInit, OnDestroy, OnChanges {

    documentTypes: OnBaseDocumentType[] = [];
    selectDocumentType: OnBaseDocumentType = { id: -1, name: "-- Select a Document Type --" };

    documentGroupDocumentTypeMap: Map<number, OnBaseDocumentType[]> = new Map<number, OnBaseDocumentType[]>();
    documentGroups: OnBaseDocumentGroup[];

    selectDocumentGroup: OnBaseDocumentGroup = { id: -1, name: "-- Select a Document Group --" };


    @Output() docSelected: EventEmitter<any> = new EventEmitter<any>();

    apiSearchRun: boolean = false;
    applicationSearchRun: boolean = false;
    organizationSearchRun: boolean = false;
    rbdmsNumberSearchRun: boolean = false;

    _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    @Input() set formGroup(group: FormGroup) {
        this._formGroup = group;
    }

    @Input() generatedApplicationNumber: string = null;
    @Input() generateForm: boolean = true;

    @Input() groupName: string;
    @Input() paperApplication: boolean = false;
    

    get apiValid(): boolean {
        let valid = true;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("apiNumber");
            valid = ctrl && (ctrl.disabled || ctrl.value);
            let found = this.formGroup.get("apiFound");
            valid = valid && (!found || found.value);
        }
        return valid;
    }

    get applicationNumberValid(): boolean {
        let valid = true;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("applicationNumber");
            valid = ctrl && (ctrl.disabled || ctrl.value);
            let found = this.formGroup.get("applicationNumberFound");
            valid = valid && (!found || found.value);
        }
        return valid;
    }

    get organizationNumberValid(): boolean {
        let valid = true;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("organizationNumber");
            valid = ctrl && (ctrl.disabled || ctrl.value);
            let found = this.formGroup.get("organizationNumberFound");
            valid = valid && (!found || found.value);
        }
        return valid;
    }

    get rbdmsNumberValid(): boolean {
        let valid = true;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("rbdmsNumber");
            valid = ctrl && (ctrl.disabled || ctrl.value);
            let found = this.formGroup.get("rbdmsNumberFound");
            valid = valid && (!found || found.value);
        }
        return valid;
    }


    get documentsInvalid(): boolean {
        let invalid = false;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("documentType");
            invalid = ctrl && ctrl.invalid;
        }
        return invalid;
    }

    get pagesInvalid(): boolean {
        let invalid = false;
        if (this.formGroup) {
            let ctrl = this.formGroup.get("pages");
            invalid = ctrl && ctrl.invalid;
        }
        return invalid;
    }

    get hasSearchOption(): boolean {
        return (this.apiValid || this.applicationNumberValid || this.organizationNumberValid);
    }

    @Input() organization: OrganizationStub;

    runApiSearch: boolean = false;
    runAppSearch: boolean = false;
    runOrgSearch: boolean = false;
    runRBDMSSearch: boolean = false;

    get selectedDocumentGroup(): OnBaseDocumentGroup {
        if (this.formGroup == null) return this.selectDocumentGroup;
        const ctrl = this.formGroup.get("documentGroup");
        if (ctrl == null) return this.selectDocumentGroup;
        const selected: OnBaseDocumentGroup = this.documentGroups.find(g => g.id === parseInt(ctrl.value));
        if (selected == null) return this.selectDocumentGroup;
        return selected;
    }

    get selectedDocumentType(): OnBaseDocumentType {
        if (this.formGroup == null) return this.selectDocumentType;
        const ctrl = this.formGroup.get("documentType");
        if (ctrl == null) return this.selectDocumentType;
        const selected: OnBaseDocumentType = this.documentTypes.find(g => g.id === parseInt(ctrl.value));
        if (selected == null) return this.selectDocumentType;
        return selected;
    }


    subscription: Subscription = new Subscription();

    constructor(private builder: FormBuilder, private mappingService: OnBaseIntegrationAndMappingService, private documentService: DocumentManagementService,
        private wellService: WellService, private instanceService: FlowInstanceService, private organizationService: OrganizationService) { }

    ngOnInit() {  
        const documentGroup$ = this.documentService.getAllDocumentGroups().pipe(tap((groups: OnBaseDocumentGroup[]) => {
            this.documentGroups = groups;
            this.documentGroups.unshift(this.selectDocumentGroup);
        })).subscribe(
            (groups: OnBaseDocumentGroup[]) => {

            },
            (error) => { console.error(error); }
        );
        this.subscription.add(documentGroup$);

        this.documentTypes = [];
        this.documentTypes.unshift(this.selectDocumentType);
        this.documentGroupDocumentTypeMap.set(this.selectDocumentType.id, []);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["formGroup"]) {
            this.formGroup = <FormGroup>changes["formGroup"].currentValue;
        }
    }

    apiSearch(): void {
        let ctrl = this.formGroup.get("apiNumber");
        if (ctrl && ctrl.value) {
            this.formGroup.get("apiFound").patchValue(false);
            this.runApiSearch = true;
            let apiSearch$ = this.wellService.getWellById(ctrl.value).pipe().subscribe(
                (well) => {
                    this.formGroup.get("apiNumber").markAsDirty();
                    this.formGroup.get("apiFound").patchValue(true);
                    this.formGroup.get("apiFound").updateValueAndValidity();
                    this.runApiSearch = false;
                    this.apiSearchRun = true;
                },
                (error) => {
                    this.formGroup.get("apiNumber").markAsDirty(); 
                    this.formGroup.get("apiFound").updateValueAndValidity();
                    this.runApiSearch = false;
                    this.apiSearchRun = true;
                    console.error(error);
                }
            );
            this.subscription.add(apiSearch$);
        }
    }

    appNumberSearch(): void {
        let ctrl = this.formGroup.get("applicationNumber");
        if (ctrl && ctrl.value) {
            this.formGroup.get("applicationNumberFound").patchValue(false);
            let spec = new FlowIndexSpec();
            spec.flowIdentifier = ctrl.value;
            this.runAppSearch = true;
            let indexSearch$ = this.instanceService.findFlowIndicies(spec).pipe().subscribe(
                (index) => {
                    this.applicationSearchRun = true;
                    if (index.length > 0) {
                        this.formGroup.get("applicationNumber").markAsDirty();
                        this.formGroup.get("applicationNumberFound").patchValue(true);
                        this.formGroup.get("applicationNumberFound").updateValueAndValidity();                        
                    }                   
                    this.runAppSearch = false;
                },
                (error) => {
                    this.formGroup.get("applicationNumber").markAsDirty();
                    if (ctrl.value === this.generatedApplicationNumber) {
                        this.formGroup.get("applicationNumberFound").patchValue(true);                        
                    }
                    this.formGroup.get("applicationNumberFound").updateValueAndValidity();
                    this.runAppSearch = false;
                    this.applicationSearchRun = true;
                    console.error(error);
                }
            )
            this.subscription.add(indexSearch$);
        }
        
    }

    buildForm(): FormGroup {        
        return this.builder.group({
            documentGroup: [-1, [Validators.required, Validators.min(0)]],
            documentType: [-1, [Validators.required, Validators.min(0)]],
            apiNumber: ["", [requireOneOption([this.apiValid, this.applicationNumberValid, this.organizationNumberValid, this.rbdmsNumberValid])]],
            apiFound: [ false, Validators.requiredTrue],
            applicationNumber: ["", [requireOneOption([this.apiValid, this.applicationNumberValid, this.organizationNumberValid, this.rbdmsNumberValid])]],
            applicationNumberFound: [ false, Validators.requiredTrue],
            organizationNumber: ["", [requireOneOption([this.apiValid, this.applicationNumberValid, this.organizationNumberValid, this.rbdmsNumberValid])]],
            organizationNumberFound: [false, Validators.requiredTrue],
            rbdmsNumber: ["", [requireOneOption([this.apiValid, this.applicationNumberValid, this.organizationNumberValid, this.rbdmsNumberValid])]],
            rbdmsNumberFound: [false, Validators.requiredTrue],
            confidential: [false, []],
            legalReview: [false, []],
            pages: [0, [Validators.min(1), Validators.required]]
        });
    }

    docTypeChanged(): void {
        let documentGroup: any = "";
        let docType: any = "";
        let documentGroupCtrl = this.formGroup.get("documentGroup");
        if (documentGroupCtrl) {
            documentGroup = documentGroupCtrl.value;
        }
        let docCtrl = this.formGroup.get("documentType");
        if (docCtrl) {
            docType = docCtrl.value;
        }
        this.docSelected.emit({ index: this.groupName, documentGroup: documentGroup, documentType: docType });
    }

    documentGroupChanged(event: Event): void {
        let ctrl = this.formGroup.get("documentGroup");
        if (ctrl) {
            const value = ctrl.value;
            this.documentTypes = [];
            const typeCtrl = this.formGroup.get("documentType");
            if (typeCtrl) {
                typeCtrl.setValue(this.selectDocumentType.id);
            }
            let types$ = this.getDocumentTypesByGroup(value).pipe().subscribe(
                (types: OnBaseDocumentType[]) => {
                    this.documentTypes = types;
                    if (this.documentTypes.findIndex(d => d.id === this.selectDocumentType.id) === -1) {
                        this.documentTypes.unshift(this.selectDocumentType);
                    }
                },
                (error) => {
                    console.error(error);
                    if (this.documentTypes.findIndex(d => d.id === this.selectDocumentType.id) === -1) {
                        this.documentTypes.unshift(this.selectDocumentType);
                    }
                }
            );
            this.subscription.add(types$);
        }
    }

    favorPaperSort(docs: OnBaseDocumentType[]): OnBaseDocumentType[] {
        let sorted: OnBaseDocumentType[] = [];
        const paperTypes = docs.filter(d => d.name.toLocaleLowerCase().includes("paper application"));
        const nonPaperTypes = docs.filter(d => !d.name.toLocaleLowerCase().includes("paper application"));
        const sortedPaper = paperTypes.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
        });
        const sortedNonPaper = nonPaperTypes.sort((a, b) => {
            if (a.name > b.name) return  1;
            if (a.name < b.name) return -1;
            return 0;
        })
        sorted = sortedPaper.concat(sortedNonPaper);
        return sorted;
    }

    getDocumentTypes(documentGroup: number): Observable<OnBaseDocumentType[]> {
        let obs$: Observable<OnBaseDocumentType[]>;
        if (this.documentGroupDocumentTypeMap.has(documentGroup)) {
            let types = this.documentGroupDocumentTypeMap.get(documentGroup);
            obs$ = of(types);
        } else {
            obs$ = this.documentService.getDocumentTypesByDocumentGroup(documentGroup).pipe(tap((types: OnBaseDocumentType[]) => {
                this.documentGroupDocumentTypeMap.set(documentGroup, types);
            }));
        }
        return obs$;
    }

    getDocumentTypesByGroup(group: number): Observable<OnBaseDocumentType[]> {
        let obs$: Observable<OnBaseDocumentType[]>;
        if (this.documentGroupDocumentTypeMap.has(group)) {
            let types = this.documentGroupDocumentTypeMap.get(group);
            obs$ = of(types);
        } else {
            obs$ = this.documentService.getDocumentTypesByDocumentGroup(group).pipe(
                map((types: OnBaseDocumentType[]) => {
                    if (this.paperApplication) {
                        types = this.favorPaperSort(types);
                    }
                    this.documentGroupDocumentTypeMap.set(group, types);
                    return types;
                })
            )
        }
        return obs$;
    }

    invalidateField(fieldName: string): void {
        this.formGroup.get(fieldName).setValue(false);
        switch (fieldName) {
            case "apiFound":
                this.apiSearchRun = false;
                break;
            case "rbdmsNumberFound":
                this.rbdmsNumberSearchRun = false;
                break;
            case "organizationNumberFound":
                this.organizationSearchRun = false;
                break;
            case "applicationNumberFound":
                this.applicationSearchRun = false;
                break;
        }
    }

    organizationSearch(): void {
        let ctrl = this.formGroup.get("organizationNumber");
        if (ctrl && ctrl.value) {
            this.formGroup.get("organizationNumberFound").patchValue(false);
            this.formGroup.get("rbdmsNumber").patchValue("");
            this.formGroup.get("rbdmsNumberFound").patchValue(false);
            this.organization = null;
            this.runOrgSearch = true;
            let orgSearch$ = this.organizationService.getOrganizationStub(ctrl.value).pipe().subscribe(
                (org: OrganizationStub) => {
                    this.formGroup.get("organizationNumber").markAsDirty();
                    this.formGroup.get("organizationNumberFound").patchValue(true);
                    this.formGroup.get("organizationNumberFound").updateValueAndValidity();
                    this.formGroup.get("rbdmsNumber").patchValue((org.historicalOwnerNumber != null) ? org.historicalOwnerNumber : "");
                    this.formGroup.get("rbdmsNumber").updateValueAndValidity();
                    this.formGroup.get("rbdmsNumberFound").patchValue(org.historicalOwnerNumber != null && org.historicalOwnerNumber.length > 0);
                    this.organization = org;
                    this.runOrgSearch = false;
                    this.organizationSearchRun = true;
                },
                (error) => {
                    this.formGroup.get("organizationNumber").markAsDirty();
                    this.formGroup.get("organizationNumberFound").updateValueAndValidity();
                    this.runOrgSearch = false;
                    this.organizationSearchRun = true;
                    console.error(error);
                });
            this.subscription.add(orgSearch$);
        }
    }

    rbdmsSearch(): void {
        let ctrl = this.formGroup.get("rbdmsNumber");        
        if (ctrl && ctrl.value) {
            this.formGroup.get("rbdmsNumberFound").patchValue(false);
            this.formGroup.get("organizationNumberFound").patchValue(false);
            this.formGroup.get("organizationNumber").patchValue("");
            this.organization = null;
            this.runRBDMSSearch = true;
            const rbdmsSearch$ = this.organizationService.getOrganizationStubs([ ctrl.value ]).pipe().subscribe(
                (orgs: OrganizationStub[]) => {
                    if (orgs.length === 1) {
                        this.organization = orgs[0];
                    } else {
                        let registered = orgs.find(o => o.hasRegistered === true);
                        if (registered) {
                            this.organization = registered;
                        } else {
                            this.organization = orgs[0];
                        }
                    }
                    if (this.organization != null) {
                        this.formGroup.get("rbdmsNumber").markAsDirty();
                        this.formGroup.get("rbdmsNumberFound").patchValue(true);
                        this.formGroup.get("rbdmsNumberFound").updateValueAndValidity();
                        this.formGroup.get("organizationNumber").patchValue(this.organization.id);
                        this.formGroup.get("organizationNumber").updateValueAndValidity();
                        this.formGroup.get("organizationNumberFound").patchValue(true);
                        this.formGroup.get("organizationNumberFound").updateValueAndValidity();
                    }
                    this.runRBDMSSearch = false;
                    this.rbdmsNumberSearchRun = true;
                },
                (error) => {
                    this.formGroup.get("rbdmsNumber").markAsDirty();
                    this.formGroup.get("rbdmsNumberFound").updateValueAndValidity();
                    this.runRBDMSSearch = false;
                    this.rbdmsNumberSearchRun = true;
                    console.error(error);
                }
            );
            this.subscription.add(rbdmsSearch$);            
        }
    }
}
